import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Radio, Money, TextField, Conditional, ULID } from '../../Components/Form';

const EditItem = ({isOpen, onSave, item, onClose, removeItem}) => {
    return <Modal title="Add Items" isOpen={isOpen} setIsOpen={onClose} dismissible>
        {isOpen && <Inner {...{item, onSave, removeItem}} />}
    </Modal>
}

const Inner = ({item, onSave, removeItem}) => {
    const handleSave = (data) => {
        // Ensure '1' is always sent for units, in case it's hidden by the conditional
        onSave({units: 1, ...data});
    }
    return <Form onSubmit={handleSave} data={item} closeModalOnSubmit>
        <ULID name="pricingItemId" />
        <TextField name="name" label="Name" validators={[]} />
        <TextField name="description" label="Description" validators={[]} />
        <Money name="unitPrice" label="Unit Price" validators={[]} />
        <Radio layout="SmallCards" name="displayPrice" label="Display price" validators={[]}
            options={[
                {
                    label: 'Total',
                    value: 'Total',
                },
                {
                    label: 'Individual',
                    value: 'Individual',
                },
            ]}
            help={(v) => v === 'Total' ?
                '"Total" pricing will show a single price without a unit count.' :
                '"Individual" pricing will show the number of items and the price per unit.'
            }
        />
        <Conditional condition={formData => formData.displayPrice === 'Individual'}>
            <TextField type="number" name="units" label="Count" validators={[]} />
        </Conditional>
        <Actions submit={{label: 'Update'}} cancel extra={{label: 'Remove', className: 'btn-danger', closeModal: true, onClick: removeItem}} />
    </Form>
}

export default EditItem;
